import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import '../inputs.css';
import { fetchProvinces } from '../../helpers/public';
import { CircularProgress } from '@mui/material';
import { useCookies } from 'react-cookie';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 860,
    bgcolor: 'background.paper',
    borderRadius: '50px',
    textAlign: 'center',
    boxShadow: 24,
    p: '20px 20px 0 20px',
    fontFamily: 'Almarai',
};

export default function EditSub({ handleClose, handleClickAlert, selectedRows, setMessage }) {
    // const [paddingTop, setPaddingTop] = useState('150px')
    const [cookies, setCookie, removeCookie] = useCookies(['token']);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = useState({
        universities: [],
        collages: [],
        years: [],
        bachelors: [],
        subjects: [],
    });
    const [filterData, setFilterData] = useState({
        universities: [],
        collages: [],
        years: [],
        subjects: [],
    });
    const [formData, setFormData] = useState({
        university_id: selectedRows['subject.year.collage.university.id'],
        collage_id: selectedRows['subject.year.collage.id'],
        year_id: selectedRows['subject.year.id'],
        bachelor_id: selectedRows["subject.bachelor.id"],
        sub_subject_name: selectedRows.sub_subject_name,
        sub_subject_notes: selectedRows.sub_subject_notes,
        subject_id: selectedRows.subject_id
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    React.useEffect(() => {
        const fetchProvinces = async (setData, url) => {
            const token = cookies['token']
            try {
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setData(response.data);
            } catch (error) {
                console.error('Error fetching provinces:', error);
            }
        };
        fetchProvinces(setData, `${process.env.REACT_APP_URL}/houdix/seen/admin/get-all`);
    }, []);

    const handleCollagesChange = (e) => {
        setFilterData({
            ...filterData,
            collages: data.collages.filter(item => item.university_id == e.target.value)
        })
        handleInputChange(e);
    };
    const handleYearsChange = (e) => {
        setFilterData({
            ...filterData,
            years: data.years.filter(item => item.collage_id == e.target.value)
        });
        handleInputChange(e);
    };
    const handleSubjectsYearChange = (e) => {
        setFilterData({
            ...filterData,
            subjects: data.subjects.filter(item => item.year_id == e.target.value)
        });
        handleInputChange(e);
    };
    const handleSubjectsChange = (e) => {
        setFilterData({
            ...filterData,
            subjects: data.subjects.filter(item => item.bachelor_id == e.target.value)
        });
        handleInputChange(e);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFormSubmit = async (e) => {
        const token = cookies['token'];
        setIsLoading(true);
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await axios.put(`${process.env.REACT_APP_URL}/houdix/seen/admin/sub-subjects/${selectedRows.id}`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.status === 200) {
                setIsLoading(false);
                setMessage('تمت العملية بنجاح');
                handleClose()
                handleClickAlert()
            }
        } catch (error) {
            setMessage('خطأ في العملية');
            handleClose()
            handleClickAlert()
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <Modal
                open={true}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {!isLoading ? (
                        <>
                            <Typography sx={{ fontFamily: 'Almarai' }} id="modal-modal-title" variant="h3" component="h2">
                                تعديل تصنيف
                            </Typography>
                            <div className="center" style={{ paddingTop: '60px' }}>
                                <form onSubmit={handleFormSubmit}>
                                    <div className='input-contener'>
                                        <div className="inputbox">
                                            <input
                                                dir='rtl'
                                                type="text"
                                                name="sub_subject_notes"
                                                value={formData.sub_subject_notes}
                                                onChange={handleInputChange}
                                            />
                                            <span>ملاحظة</span>
                                        </div>
                                        <div className="inputbox">
                                            <input
                                                dir='rtl'
                                                type="text"
                                                name="sub_subject_name"
                                                value={formData.sub_subject_name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                            <span>الاسم</span>
                                        </div>
                                        {selectedRows["subject.year.id"] ? (
                                            <>
                                                <div className="inputbox">
                                                    <select
                                                        dir='rtl'
                                                        name="university_id"
                                                        onChange={handleCollagesChange}
                                                        onClick={handleCollagesChange}
                                                        value={formData.university_id}
                                                        required
                                                    >
                                                        <option value="">اختر جامعة</option>
                                                        {data.universities.map((university) => (
                                                            <option key={university.id} value={university.id}>
                                                                {university.university_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="inputbox">
                                                    <select
                                                        dir='rtl'
                                                        name="collage_id"
                                                        onChange={handleYearsChange}
                                                        onClick={handleYearsChange}
                                                        value={formData.collage_id}
                                                        required
                                                    >
                                                        <option value="">اختر كلية</option>
                                                        {filterData.collages.map((collage) => (
                                                            <option key={collage.id} value={collage.id}>
                                                                {collage.collage_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="inputbox">
                                                    <select
                                                        dir='rtl'
                                                        name="year_id"
                                                        onChange={handleSubjectsYearChange}
                                                        onClick={handleSubjectsYearChange}
                                                        value={formData.year_id}
                                                        required
                                                    >
                                                        <option value="">اختر سنة</option>
                                                        {filterData.years.map((year) => (
                                                            <option key={year.id} value={year.id}>
                                                                {year.year_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="inputbox">
                                                <select
                                                    dir='rtl'
                                                    name="bachelor_id"
                                                    onChange={handleSubjectsChange}
                                                    onClick={handleSubjectsChange}
                                                    value={formData.bachelor_id}
                                                    required
                                                >
                                                    <option value="">اختر فرع</option>
                                                    {data.bachelors.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.bachelor_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        <div className="inputbox">
                                            <select
                                                dir='rtl'
                                                name="subject_id"
                                                value={formData.subject_id}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">اختر مادة</option>
                                                {filterData.subjects.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.subject_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="inputbox">
                                        <button type="submit" disabled={isSubmitting}>
                                            موافق
                                        </button>
                                        <button type="button" onClick={handleClose}>
                                            إلغاء
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>
                    ) : (
                        <div style={{ display: 'flex', height: "300px", justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </div>
                    )}
                </Box>
            </Modal>
        </div>
    );
}